<template>
  <div
    class="border-adk-secondaryLightGrey h-10 w-10 animate-spin rounded-full border-8 border-t-adk-main-accent"
  ></div>
</template>
